import { TradingChip, TradingSpinner } from '@trading-ui/core';
import { BinIcon, PencilIcon } from '@trading-ui/icons';

import i18n from '@/i18n/config';

import type { User } from '@/interfaces';

type Params = {
  setSelectedUser: (user: User) => void;
  handleDeleteUser: (user: User) => void;
  deletingId: number | null;
};

export const getCompanyUsersColumns = ({ setSelectedUser, handleDeleteUser, deletingId }: Params) => [
  {
    Header: i18n.t('settings.companyDetailsTab.companyUsers.columns.name'),
    accessor: 'name',
    width: 60,
    cellStyle: () => ({ backgroundColor: 'rgba(4, 120, 178, 0.2)', color: '#0478B2' }),
  },
  {
    Header: i18n.t('settings.companyDetailsTab.companyUsers.columns.email'),
    accessor: 'email',
    width: 60,
  },
  {
    Header: i18n.t('settings.companyDetailsTab.companyUsers.columns.associatedTo'),
    accessor: 'plants',
    Cell: ({ row }: { row: { original: User } }) => (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
        {(row.original.plants ?? []).map((plant) => (
          <TradingChip key={plant.id} label={plant.alias} />
        ))}
      </div>
    ),
  },
  {
    Header: i18n.t('settings.companyDetailsTab.companyUsers.columns.role'),
    accessor: 'role',
    width: 30,
  },
  {
    Header: '',
    accessor: 'edit',
    width: 20,
    cellStyle: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'rgba(4, 120, 178, 0.2)',
      color: '#0478B2',
    }),
    Cell: ({ row }: { row: { original: User } }) => (
      <PencilIcon size={24} className="icon-hover" onClick={() => setSelectedUser(row.original)} />
    ),
  },
  {
    Header: '',
    accessor: 'delete',
    width: 20,
    cellStyle: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'rgba(4, 120, 178, 0.2)',
      color: '#0478B2',
    }),
    Cell: ({ row }: { row: { original: User } }) =>
      deletingId === row.original.id ? (
        <TradingSpinner size={24} color="secondary" />
      ) : (
        <BinIcon size={24} className="icon-hover" onClick={() => handleDeleteUser(row.original)} />
      ),
  },
];
